import { CursorPaginatedApiResponse } from '../../../types/responses/cursor-paginated.response';
import { client } from './client';
import { SearchColorBooksApiRequest } from '../../../types/requests/color-books/search-color-books.request';
import { LineweightApiModel } from '../../../types/models/lineweight.model';

export const searchLineweights = <T extends LineweightApiModel>(params: SearchColorBooksApiRequest) =>
  client.get<CursorPaginatedApiResponse<T>>(`/lineweights`, { params });
